import { createContext, useState, useContext, useEffect, useMemo } from 'react';
import CreationService from 'services/CreationService';
import { useQuery } from '@tanstack/react-query';
import { useAuthUser } from 'features/auth/AuthUserContext';

const CreationsContext = createContext({
  creations: [],
  setCreations: () => {},
});

export function CreationsProvider({ children }) {
  const [creations, setCreations] = useState([]);
  const value = useMemo(() => ({ creations, setCreations }), [creations]);

  return <CreationsContext.Provider value={value}>{children}</CreationsContext.Provider>;
}

export function useCreations() {
  const { user } = useAuthUser();
  const { creations, setCreations } = useContext(CreationsContext);

  const { refetch, isFetching } = useQuery({
    queryKey: ['creations'],
    queryFn: async () => {
      if (user?.id) {
        const response = await CreationService.findAll({ status: 'available' });
        setCreations(response.data);
        return response.data;
      }
    },
    options: {
      enabled: false,
    },
  });

  useEffect(() => {
    if (user?.id) {
      refetch();
    }
  }, [user?.id, refetch]);

  return [creations, refetch, isFetching];
}
